/* eslint-disable  */
import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Avatar, Badge, IconButton } from "@material-ui/core";
import { MessageSharp, NotificationImportant } from "@material-ui/icons";
import {
  Menu,
  X,
  Home,
  Users,
  Layers,
  Package,
  ShoppingCart,
  CheckCircle,
  Truck,
  XCircle,
  BarChart2,
  LogOut,
  ClipboardList,
  Tag,
} from "lucide-react";

// Redux Actions
import { GetUserProfile, SignOut } from "../services/Actions/authActions";
import { GetMartOfficersMessagesUnread } from "../services/Actions/MessagesAction";
import { GetNotificationsByMartOfficers } from "../services/Actions/notificationAction";

function RenderHirePurchasePage({ children, title }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const auth = useSelector((state) => state.auth);
  const message = useSelector((state) => state?.message);
  const { mart_notifications } = useSelector((state) => state?.notification);
  const { user } = auth;

  useEffect(() => {
    dispatch(GetUserProfile());
    dispatch(GetMartOfficersMessagesUnread());
    dispatch(GetNotificationsByMartOfficers());
  }, [dispatch]);

  const handleLogout = () => {
    dispatch(SignOut());
    setTimeout(() => window.location.reload(false), 500);
  };

  const navItems = [
    { label: "Dashboard", icon: <Home size={18} />, path: "/mart/home" },
    {
      label: "Mart Deductions",
      icon: <Layers size={18} />,
      path: "/mart/mart-deduction",
    },
    { label: "Suppliers", icon: <Users size={18} />, path: "/mart/vendors" },
    { label: "Category", icon: <Tag size={18} />, path: "/mart/category" },
    { label: "Products", icon: <Package size={18} />, path: "/mart/product" },
    { label: "Orders", icon: <ShoppingCart size={18} />, path: "/mart/order" },
    {
      label: "Requested Orders",
      icon: <ClipboardList size={18} />,
      path: "/mart/request-order",
    },
    {
      label: "Booked Order",
      icon: <CheckCircle size={18} />,
      path: "/mart/processed-order",
    },
    {
      label: "Approved Order",
      icon: <CheckCircle size={18} />,
      path: "/mart/approved-order",
    },
    {
      label: "Shipped Order",
      icon: <Truck size={18} />,
      path: "/mart/shipped-order",
    },
    {
      label: "Rejected Order",
      icon: <XCircle size={18} />,
      path: "/mart/rejected-order",
    },
    {
      label: "Status of orders",
      icon: <BarChart2 size={18} />,
      path: "/mart/status-order",
    },
    { label: "Report", icon: <BarChart2 size={18} />, path: "/mart/report" },
  ];

  const NavLink = ({ item }) => {
    const isActive = location.pathname === item.path;
    return (
      <button
        onClick={() => {
          history.push(item.path);
          setIsMobileMenuOpen(false);
        }}
        className={`w-full flex items-center gap-3 px-3 py-3 rounded-md transition-all duration-200 group ${
          isActive
            ? "bg-indigo-600 text-white shadow-md shadow-indigo-200"
            : "text-slate-600 hover:bg-slate-100 hover:text-indigo-600"
        }`}
      >
        <span
          className={`${
            isActive
              ? "text-white"
              : "text-slate-400 group-hover:text-indigo-600"
          }`}
        >
          {item.icon}
        </span>
        <span className="text-sm font-semibold">{item.label}</span>
      </button>
    );
  };

  return (
    <div className="min-h-screen bg-slate-50 flex py-1">
      {/* SIDEBAR - DESKTOP */}
      <aside
        className={`
        fixed inset-y-0 left-0 z-50 w-72 bg-white border-r border-slate-200 transform transition-transform duration-300 ease-in-out
        lg:translate-x-0 ${
          isMobileMenuOpen ? "translate-x-0" : "-translate-x-full"
        }
      `}
      >
        <div className="h-full flex flex-col">
          {/* Logo Section */}
          <div className="p-3 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="w-6 h-6 bg-indigo-600 rounded-lg flex items-center justify-center text-white font-bold">
                M
              </div>
              <span className="text-md font-bold text-slate-800">
                Mart Admin
              </span>
            </div>
            <button
              onClick={() => setIsMobileMenuOpen(false)}
              className="lg:hidden p-2 text-slate-500"
            >
              <X size={20} />
            </button>
          </div>

          {/* Navigation Links */}
          <nav className="flex-1 px-2 py-1 overflow-y-auto space-y-1 custom-scrollbar">
            {navItems.map((item) => (
              <NavLink key={item.path} item={item} />
            ))}
          </nav>

          {/* User Profile Footer */}
          <div className="p-2 border-t border-slate-100 bg-slate-50/50">
            <div className="flex items-center gap-2 mb-2 px-2">
              <img
                className="w-8 h-8 rounded-full border-2 border-white shadow-sm"
                src={user?.profile_image || "/images/dev/avatar1.png"}
                alt="User"
              />
              <div className="overflow-hidden">
                <p className="text-xs font-bold text-slate-800 truncate">
                  {user?.name || "Mart Officer"}
                </p>
                <p className="text-xs text-slate-500 truncate">Administrator</p>
              </div>
            </div>
            <button
              onClick={handleLogout}
              className="w-full flex items-center justify-center gap-2 px-2 py-2 bg-white border border-slate-200 text-rose-600 rounded-xl hover:bg-rose-50 hover:border-rose-100 transition-colors font-semibold text-sm shadow-sm"
            >
              <LogOut size={16} />
              Logout
            </button>
          </div>
        </div>
      </aside>

      {/* MAIN CONTENT AREA */}
      <main className="flex-1 flex flex-col min-w-0 lg:pl-72">
        {/* TOP BAR */}
        <header className="sticky top-0 z-40 bg-white/60 backdrop-blur-md border-b border-slate-200 px-4 sm:px-3 lg:px-4 py-2">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <button
                onClick={() => setIsMobileMenuOpen(true)}
                className="lg:hidden p-2 rounded-lg bg-slate-100 text-slate-600"
              >
                <Menu size={18} />
              </button>
              <h1 className="text-md font-bold text-slate-800 hidden sm:block">
                Dashboard
              </h1>
            </div>

            <div className="flex items-center gap-2 sm:gap-4">
              <IconButton onClick={() => history.push("/mart/messages")}>
                <Badge
                  badgeContent={message?.martMessagesUnread}
                  color="secondary"
                >
                  <MessageSharp className="text-slate-500" />
                </Badge>
              </IconButton>

              <IconButton onClick={() => history.push("/mart/notifications")}>
                <Badge
                  badgeContent={mart_notifications?.length}
                  color="secondary"
                >
                  <NotificationImportant className="text-slate-500" size={16} />
                </Badge>
              </IconButton>

              <div className="h-8 w-px bg-slate-200 mx-1 hidden sm:block"></div>

              <img
                onClick={() => history.push("/mart/profile")}
                className="w-7 h-7 rounded-full cursor-pointer ring-2 ring-transparent hover:ring-indigo-500 transition-all shadow-sm"
                src={user?.profile_image || "/images/dev/avatar1.png"}
                alt="Avatar"
              />
            </div>
          </div>
        </header>

        {/* PAGE CONTENT */}
        <div className="p-4 sm:p-6 lg:p-8">
          <div className="mb-6">
            <h2 className="text-2xl font-black text-slate-800 tracking-tight">
              {title}
            </h2>
            <div className="h-1 w-12 bg-indigo-600 rounded-full mt-2"></div>
          </div>
          <div className="animate-in fade-in duration-500">{children}</div>
        </div>
      </main>

      {/* MOBILE OVERLAY */}
      {isMobileMenuOpen && (
        <div
          className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-40 lg:hidden"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}
    </div>
  );
}

export default RenderHirePurchasePage;
